import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageService } from 'src/app/shared/message.service';
import { RestService } from 'src/app/shared/services/rest.service';
import { SessionService } from 'src/app/shared/services/session.service';


@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  // Variáveis para criação de chamado.
  resourceFormSearch: FormGroup;
  bsModal: BsModalRef;
  guidText: any;
  veiculo: any;
  dadosVeiculo: String;
  protocolo: String;
  campoPecaAtiva: number;
  peca: any = null;
  infosPeca: any;
  orcamento: any;
  data = new Date

  dataAtual: String;
  usuario: String;

  // 0 Cadastrar Chamado
  // 1 Ver Chamado
  // 2 Editar Chamado
  statusFunc: number;

  ListaTiposTickets: Array<any> = [
    { "value": 0, "label": "Duvida" },
    { "value": 1, "label": "Erro" },
    { "value": 2, "label": "Sugestão" },
    { "value": 3, "label": "Peça não Localizada" },
    { "value": 4, "label": "Veiculo não localizado" },
    { "value": 5, "label": "Sugerir revisão de peça" }
  ];

  //Variáveis para exibição de chamado

  exTipoTicket: any;
  exEmpresa: any;
  exSolicitacao: any;
  exProtocolo: any;
  exVeiculo: any;
  exPlaca: any;
  exPeca: any
  exAnexo: any;

  //Variáveis para exibição de chamado
  edIdTicket: any;
  edTipoTicket: any;
  edEmpresa: any;
  edSolicitacao: any;
  edProtocolo: any;
  edVeiculo: any;
  edPlaca: any;
  edPeca: any
  edAnexo: any;
  edStatus: any;

  statusTicket: any = [
    { "value": 0, "label": "Novo" },
    { "value": 1, "label": "Em andamento" },
    { "value": 2, "label": "Feedback" },
    { "value": 3, "label": "Resolvido" },
    { "value": 4, "label": "Fechado" }
  ];

  constructor(
    private router: ActivatedRoute,
    private formBuilder: FormBuilder,
    private info: MessageService,
    public refModal: BsModalRef,
    private http: HttpClient,
    private rest: RestService,
    private session: SessionService) { }


  ngOnInit(): void {

    if (this.statusFunc == 0) {
      this.dataAtual = this.data.getDate() + "/" + this.data.getMonth() + "/" + this.data.getFullYear();
      this.usuario = this.session.getEmail();

      this.buildResourceForm();

      // Preenchendo o campo "veiculo" com dados passados do orçamento.
      this.dadosVeiculo = this.veiculo['dados'].marca_descricao + " " +
        this.veiculo['dados'].geracao_descricao + " - " + this.veiculo['dados'].modelo_descricao;
      this.resourceFormSearch.get('veiculo').setValue(this.dadosVeiculo)
      this.resourceFormSearch.get('veiculo').disable()

      // Preenchendo o campo "protocolo" com dados passados do orçamento.
      this.resourceFormSearch.get('protocolo').setValue(this.protocolo);
      this.resourceFormSearch.get('protocolo').disable()

      // Preenchendo o campo "placa" com dados passados do orçamento
      this.resourceFormSearch.get('placa').setValue(this.veiculo['dados'].placa)
      this.resourceFormSearch.get('placa').disable()

      // Preenchendo o campo "empresa" com dados passados do Session Service.
      var empresa = this.session.getCurrentEmpresa()
      this.resourceFormSearch.get('empresa').setValue(empresa['razaoSocial'])
      this.resourceFormSearch.get('empresa').disable()

      if (this.peca == null) {
        this.campoPecaAtiva = 0
        this.infosPeca = null

      } else {
        this.infosPeca = this.peca['descricaoPecaCiclo'] + " - " + this.peca['partNumber'][0].codigoPN
        this.campoPecaAtiva = 1;
        this.resourceFormSearch.get('peca').setValue(this.infosPeca)
        this.resourceFormSearch.get('peca').disable()
      }
    } else if (this.statusFunc == 1) {
      this.buildResourceForm();
      this.resourceFormSearch.get('tipoTicket').setValue(this.exTipoTicket)
      this.resourceFormSearch.get('empresa').setValue(this.exEmpresa)
      this.resourceFormSearch.get('solicitacao').setValue(this.exSolicitacao)
      this.resourceFormSearch.get('protocolo').setValue(this.exProtocolo)
      this.resourceFormSearch.get('veiculo').setValue(this.exVeiculo)
      this.resourceFormSearch.get('placa').setValue(this.exPlaca)
      this.resourceFormSearch.get('peca').setValue(this.exPeca)
      this.resourceFormSearch.get('anexo').setValue(this.exAnexo)
      this.resourceFormSearch.disable()
    } else if (this.statusFunc == 2) {
      this.buildResourceForm();
      this.resourceFormSearch.get('tipoTicket').setValue(this.edTipoTicket)
      this.resourceFormSearch.get('empresa').setValue(this.edEmpresa)
      this.resourceFormSearch.get('solicitacao').setValue(this.edSolicitacao)
      this.resourceFormSearch.get('protocolo').setValue(this.edProtocolo)
      this.resourceFormSearch.get('veiculo').setValue(this.edVeiculo)
      this.resourceFormSearch.get('placa').setValue(this.edPlaca)
      this.resourceFormSearch.get('peca').setValue(this.edPeca)
      this.resourceFormSearch.get('anexo').setValue(this.edAnexo)
      this.resourceFormSearch.get('status').setValue(this.edStatus)

      this.resourceFormSearch.get('empresa').disable()
      this.resourceFormSearch.get('placa').disable()
      this.resourceFormSearch.get('protocolo').disable()
      this.resourceFormSearch.get('veiculo').disable()
    }
  }

  buildResourceForm() {
    this.resourceFormSearch = this.formBuilder.group({
      tipoTicket: [null, [Validators.required]],
      empresa: [null, [Validators.required]],
      solicitacao: [null, [Validators.required]],
      protocolo: [null, [Validators.required]],
      veiculo: [null, [Validators.required]],
      placa: [null, [Validators.required]],
      peca: [null, [Validators.required]],
      anexo: [null, [Validators.required]],
      status:[null,[Validators.required]]
    });
  }

  mostrarDados() {
  }

  enviar() {
    let postData = {
      "method": "POST",
      "tipoTicket": this.resourceFormSearch.get('tipoTicket')?.value,
      "empresa": this.resourceFormSearch.get('empresa')?.value,
      "solicitacao": this.resourceFormSearch.get('solicitacao')?.value,
      "protocolo": this.resourceFormSearch.get('protocolo')?.value,
      "peca": this.infosPeca,
      "veiculo": this.resourceFormSearch.get('veiculo')?.value,
      "placa": this.resourceFormSearch.get('placa')?.value,
      "status": 0,
      "dataCriacao": this.dataAtual,
      "criador": this.usuario
    }

    this.rest.postSigaHelp(postData).subscribe((data) => {
    })

    this.info.showSuccess("Ticket enviado com Sucesso !")

    this.closeModal()
  }

  editar(){
    let postData = {
      "method": "PUT",
      "id_ticket": this.edIdTicket,
      "tipo_ticket": this.resourceFormSearch.get('tipoTicket')?.value,
      "solicitacao": this.resourceFormSearch.get('solicitacao')?.value,
      "status" : this.resourceFormSearch.get('status')?.value
    }

    this.rest.putSigaHelp(postData).subscribe((data) => {
    });

    this.info.showSuccess("Ticket editado com Sucesso !")

    this.closeModal()
  }

  closeModal() {
    this.refModal.hide()
  }
}